// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ms-autosuggest {
  position: relative;
  display: inline-block;
  width: 100%;
}

.ms-input {
  width: 100%;
  box-sizing: border-box;
}

.ms-loading {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  pointer-events: none;
}

.ms-results {
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  top: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #b9c4d0;
  border-radius: 3px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  text-align: left;
}

.ms-result {
  padding: 5px 8px;
  cursor: pointer;
  display: block;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ms-result:hover {
  background: #eef4fb;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/material-autosuggest/material-autosuggest.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".ms-autosuggest {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.ms-input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.ms-loading {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #888;\n  pointer-events: none;\n}\n\n.ms-results {\n  position: absolute;\n  z-index: 20;\n  left: 0;\n  right: 0;\n  top: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  max-height: 220px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #b9c4d0;\n  border-radius: 3px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);\n  text-align: left;\n}\n\n.ms-result {\n  padding: 5px 8px;\n  cursor: pointer;\n  display: block;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ms-result:hover {\n  background: #eef4fb;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
